import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {
  // 配置默认排序
  const defaultSort = {

  }

  return (
    <>
      <Head>
        <title>{`Top Sellers | Discounted Sales Items - Crazysales.com.au`}</title>
        <meta name="keywords" content={`Top Sellers,Bargains,Discounted,Crazysales`}></meta>
        <meta name="description" content={`Find a Large selection Sales items for sale at Crazysales.com.au. Check Huge Discounts across all categories.`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <FeaturedSection type="top-seller" defaultSort={defaultSort} />
      </DefaultLayout>
    </>

  )
}